import { render, staticRenderFns } from "./QuestTab.vue?vue&type=template&id=332cd6be&"
import script from "./QuestTab.vue?vue&type=script&lang=ts&"
export * from "./QuestTab.vue?vue&type=script&lang=ts&"
import style0 from "./QuestTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports